import {Pipe, PipeTransform} from '@angular/core';
import {ResourceTypes} from 'src/app/shared/constants/resource-types';

@Pipe({name: 'displayResource', standalone: true})
export class DisplayResourcePipe implements PipeTransform {
  transform(resource: keyof typeof ResourceTypes | string): string {
    return ResourceTypes[resource] ?? resource;
  }
}
